import gql from 'graphql-tag';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import {
  UpdateMyShopBillingMethod,
  GetBillingMethod,
} from '../schemas/rql';

export const myShopBillingMethods = gql`
  fragment myShopBillingMethods on rql_Me {
    uuid
    shop {
      _id
      id
      currency
      originCountryCode
      shopType
      billingMethodStatus
      paypalSetupStatus
      paypalProfile {
        email
      }
    }
    creditCards {
      id
      last4
      cardType
      expirationYear
      expirationMonth
      cardholderName
      primaryBilling
      address {
        postalCode
        countryCode
      }
    }
  }
`;

export const GET_BILLING_METHOD = gql`
  query GetBillingMethod {
    countries {
      countries {
        name
        countryCode
        subregions {
          name
          code
        }
      }
    }
    me {
      ...myShopBillingMethods
    }
  }
  ${myShopBillingMethods}
`;

export const connectGetBillingMethod = withGraphql<GetBillingMethod.Variables, GetBillingMethod.Query>(
  GET_BILLING_METHOD,
  {
    options: {
      errorPolicy: 'all',
    },
  },
);

export const UPDATE_MY_SHOP_BILLING_METHOD = gql`
  mutation UpdateMyShopBillingMethod($input: Input_core_apimessages_UpdateBillingMethodRequest) {
    updateMyShopBillingMethod(input: $input) {
      errors {
        message
      }
      creditCard {
        id
      }
      adyenPaymentResult {
        action
        paymentStatus
        fingerprintToken
        challengeToken
        paymentData
        threeDsOneData {
          paReq
          md
          termUrl
          redirectUrl
        }
      }
      billingMethodUuid
      me {
        ...myShopBillingMethods
      }
    }
  }
  ${myShopBillingMethods}
`;

export const connectUpdateMyShopBillingMethod =
  withGraphql<UpdateMyShopBillingMethod.Variables, UpdateMyShopBillingMethod.Mutation>(
    UPDATE_MY_SHOP_BILLING_METHOD,
    {
      name: 'updateMyShopBillingMethod',
      options: {
        ssr: true,
        errorPolicy: 'all',
      },
    },
  );
